<template>
  <v-app-bar app clipped-right
    id="clientToolbar"
    class="px-2"
    color="secondary">
    <v-app-bar-nav-icon v-if="$vuetify.breakpoint.mdAndDown" class="white--text mr-2" @click="toggleNavigator"></v-app-bar-nav-icon>
    <ProfileToolkit class="d-flex align-center"></ProfileToolkit>
    <div class="cli-name d-flex align-center body-1 white--text mt-1 ml-2 mr-4">
      <span class="ruby">{{ printClientKana }}</span>
      <span class="">{{ printClientName }}</span>
    </div>
    <v-row v-if="$vuetify.breakpoint.smAndUp" align-center>
      <ArrangesToolkit class="d-flex align-center" :icon="true" :items="getArrangeItems" />
      <span class="d-flex align-center body-1 white--text ml-2">申込手配</span>
    </v-row>
    <v-spacer></v-spacer>
    <RecorderToolkit :className="'secondary darken-1 white--text mr-2'" />
    <ClientToolkits :className="'secondary darken-1 white--text mr-2'" :arranges="getArrangeItems" />
    <div class="body-1 white--text" v-if="$vuetify.breakpoint.smAndUp">
      <span class="font-weight-bold">担当：</span>{{ printAuthorName }}
    </div>
    <ConfirmModal ref="confirm"/>
  </v-app-bar>
</template>

<script>
import ProfileToolkit from './components/toolkits/profile'
import ArrangesToolkit from './components/toolkits/arranges'
import RecorderToolkit from '@/components/recorder'
import ClientToolkits from './components/toolkits'
import ConfirmModal from '@/components/modals/confirm'

export default {
  name: 'clientToolbar',
  components: {
    ProfileToolkit,
    ArrangesToolkit,
    RecorderToolkit,
    ClientToolkits,
    ConfirmModal
  },
  data () {
    return {
      config: {
        status: {
          user: false
        },
        confirm: {
          message: ''
        },
        editor: {
          active: false
        }
      },
      meta: {
      },
      store: {
        arranges: []
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      this.connectSocket()
      this.get()
    },
    update: function (req) {
      const { name, type, item } = req || {}
      if (name && this.store[name] && item && item.id) {
        let idx = this.store[name].findIndex(it => {
          return it.id === item.id
        })
        if (idx >= 0) {
          if (type === 'remove') {
            this.store[name].splice(idx, 1)
          } else if (type === 'update') {
            this.store[name].splice(idx, 1, item)
          }
        } else {
          this.store[name].push(item)
        }
      }
    },
    get: function () {
      const cid = this.$route.params.id
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.axios.post(`${this.$url.api}client/get/arranges/${cid}`, {}, {
          headers: {
            'firebase-token': token
          }
        }).then(res => {
          console.log(res)
          if (res.data && res.data.success) {
            this.$set(this.store, 'arranges', res.data.data)
          }
        }).catch(err => {
          console.log(err)
        })
      })
    },
    toggleNavigator: function () {
      this.$emit('emit', {
        dest: 'navigator',
        action: 'toggle',
        data: null
      })
    },
    connectSocket: function () {
      const socket = this.$store.getters['config/get']('socket')
      const cid = this.$route.params.id
      const user = this.$store.getters['author/get']('userid')
      if (socket && socket.connected) {
        socket.on(`EMIT_ARRANGE:${cid}`, (data) => {
          const { emitter, type, item } = data
          this.update({ name: 'arranges', type, item })
          if (user !== emitter) {
            this.notifyOthers(data)
          }
        })
      } else {
        setTimeout(() => {
          this.connectSocket()
        }, 5000)
      }
    },
    notifyOthers: function (req) {
      const { type, emitter, item } = req
      const notifies = {
        insert: {
          title: '新しい手配',
          message: `##AUTHOR##さんが新しい手配を確定しました。`
        },
        update: {
          title: '手配の更新',
          message: `##AUTHOR##さんが「##TITLE##」の手配を更新をしました。`
        },
        remove: {
          title: '手配の削除',
          message: `##AUTHOR##さんが「##TITLE##」の手配を削除しました。`
        }
      }
      let notify = notifies[type] || { title: '', message: '' }
      let authors = this.$store.getters['config/get']('authors')
      let author = authors[emitter] ? authors[emitter].name[0] : emitter
      let { title } = item
      this.$store.dispatch('notifier/addMessage', {
        title: notify.title,
        message: notify.message.replace('##AUTHOR##', author).replace('##TITLE##', title)
      })
    }
  },
  computed: {
    isDeveloper () {
      let roles = this.$store.getters['author/get']('roles')
      return roles.includes('developer')
    },
    isDeveloping () {
      return this.$store.getters['author/get']('dev')
    },
    getArrangeItems () {
      return this.store.arranges && this.store.arranges.length ? this.store.arranges.map(it => {
        return Object.assign({}, it, {
          dates: {
            start: it.start.replace('0000-00-00', ''),
            end: it.end.replace('0000-00-00', '')
          },
          status: this.$mango.status.db.length > it.status ? this.$mango.status.db[it.status] : 'unknown'
        })
      }) : []
    },
    printClientName () {
      let name = this.$store.getters['client/get']('name').join(' ')
      return (name === ' ') ? '' : name
    },
    printClientKana () {
      return this.$store.getters['client/get']('kana').join(' ')
    },
    printAuthorName () {
      let authors = this.$store.getters['config/get']('authors')
      let aid = this.$store.getters['client/get']('author')
      return authors[aid] ? authors[aid].name[0] : ''
    }
  }
}
</script>

<style lang="scss">
#clientToolbar {
  .cli-name {
    position: relative;
    .ruby {
      position: absolute;
      top: -1.5em;
      left: 0;
      font-size: .6em;
      white-space: nowrap;
    }
  }
}
</style>
